module.exports = __webpack_public_path__ + "static/media/estrias.77b86080.jpg";